// src/pages/Documentos/EditarDocumento.js
import React from "react";
import { useParams } from 'react-router-dom';
import CadastrarDocumento from "./CadastrarDocumento";

const EditarDocumento = () => {
    const { id } = useParams(); // Assumindo que a rota passa o ID do documento como parâmetro

    return <CadastrarDocumento documentoId={id} />;
};

export default EditarDocumento;
